module.exports = __webpack_public_path__ + "media/functional__tony-2.66308421.mp4";